var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 48,
    viewBox: "0 0 62 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1940_16190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8008 40H6.20072C3.53105 40 1.34766 37.8271 1.34766 35.1702V6.16305C1.34766 3.50622 3.53105 1.33331 6.20072 1.33331H49.0598C51.7295 1.33331 53.9129 3.50622 53.9129 6.16305V27.492",
    stroke: "#47D061",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08691 8.66669L24.7187 26.1142C26.2656 27.7374 28.9023 27.7397 30.4541 26.1214L47.1739 8.66669",
    stroke: "#47D061",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08691 33.3333L20.2173 21.3333",
    stroke: "#47D061",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7831 28.6666L35.0439 21.3333",
    stroke: "#47D061",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7949 33.3333C51.289 33.3333 49.099 34.6394 47.9028 36.5904V36.5365H29.8502L26.9561 39.2707L29.8502 43.4635H33.0966L35.4626 41.1631L37.8286 43.4635H47.9028V43.4095C49.099 45.3605 51.289 46.6666 53.7949 46.6666C57.5814 46.6666 60.6517 43.6815 60.6517 40C60.6517 36.3184 57.5814 33.3333 53.7949 33.3333V33.3333Z",
    stroke: "#47D061",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1940_16190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.335339de5784b29bf9e052f4921d6ebd.svg";
export { ForwardRef as ReactComponent };